import React from 'react';
import { Box, Divider } from '@mui/material';
import ServicesGrid from '../components/Services Page/ServicesGrid.tsx';
import ResourcesGrid from '../components/Services Page/ResourcesGrid.tsx';
import './Services.css';

// Fallback (your existing original JPG)
import servicesJpgFallback from '../images/services banner.jpg';

// AVIF
import services1280Avif from '../images/services-1280.avif';
import services1920Avif from '../images/services-1920.avif';
import services2560Avif from '../images/services-2560.avif';

// WebP
import services1280Webp from '../images/services-1280.webp';
import services1920Webp from '../images/services-1920.webp';
import services2560Webp from '../images/services-2560.webp';

function Services() {
  return (
    <Box className="services-page">
      <Box className="services-banner">
        <picture>
          <source
            type="image/avif"
            srcSet={`${services1280Avif} 1280w, ${services1920Avif} 1920w, ${services2560Avif} 2560w`}
            sizes="100vw"
          />
          <source
            type="image/webp"
            srcSet={`${services1280Webp} 1280w, ${services1920Webp} 1920w, ${services2560Webp} 2560w`}
            sizes="100vw"
          />
          {/* single JPG fallback only */}
          <img
            src={servicesJpgFallback}
            alt="Banner"
            className="services-banner-image"
            sizes="100vw"
            loading="eager"
            fetchPriority="high"
            decoding="async"
            width={2560}
            height={1707}
          />
        </picture>

        <Box className="services-gradient-overlay" />
      </Box>

      <Box className="services-content">
        <ServicesGrid />
        <Divider sx={{ pb: 5, visibility: 'hidden' }} />
        <ResourcesGrid />
      </Box>
    </Box>
  );
}

export default Services;
